import { Box, Divider, Typography } from '@mui/material';

export default function UserLicence() { 
  return (
    <Box
      sx={{
        mx: 'auto',
        p: 4,
        boxShadow: 3,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Política de Privacidade – Arena Esporte Total
      </Typography>

      <Typography variant="body1" paragraph>
        A sua privacidade é muito importante para nós, e por isso queremos explicar de forma clara como lidamos com os dados que você compartilha enquanto utiliza nossos serviços.
      </Typography>
      <Typography variant="body1" paragraph>
        Ao acessar e navegar pela Arena Esporte Total, algumas informações podem ser coletadas com o objetivo de melhorar continuamente a sua experiência em nosso site. Esses dados nos ajudam a oferecer um conteúdo mais personalizado, ajustado às suas preferências e hábitos de navegação.
      </Typography>
      <Typography variant="body1" paragraph>
        Nossa política de privacidade existe justamente para que você entenda como seus dados são tratados, podendo fazer escolhas conscientes durante o uso da plataforma. Recomendamos que esta política seja revisada periodicamente, pois ela pode passar por atualizações.
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" gutterBottom>O que você encontrará nesta política:</Typography>
      <ul>
        <li><Typography variant="body2">O que são cookies e para que eles servem</Typography></li>
        <li><Typography variant="body2">Se é possível identificar usuários por meio de cookies</Typography></li>
        <li><Typography variant="body2">Quais dados coletamos e como são obtidos</Typography></li>
        <li><Typography variant="body2">De que forma utilizamos essas informações</Typography></li>
        <li><Typography variant="body2">Quais conteúdos ou serviços não são cobertos por esta política</Typography></li>
        <li><Typography variant="body2">Suas opções caso prefira não compartilhar seus dados</Typography></li>
        <li><Typography variant="body2">Como usamos seus dados para personalizar a experiência</Typography></li>
        <li><Typography variant="body2">Como entrar em contato conosco para tirar dúvidas</Typography></li>
      </ul>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" gutterBottom>O que são cookies?</Typography>
      <Typography variant="body1" paragraph>
        Cookies são pequenos arquivos de texto que são armazenados no seu navegador quando você visita um site. Eles têm como objetivo lembrar preferências e comportamentos, permitindo que a navegação seja mais fluida e personalizada em visitas futuras.
      </Typography>

      <Typography variant="h6" gutterBottom>É possível ser identificado por cookies?</Typography>
      <Typography variant="body1" paragraph>
        Se você estiver navegando sem realizar login ou cadastro, os cookies armazenam apenas dados anônimos. Caso você se identifique, essas informações podem ser associadas ao seu perfil.
      </Typography>

      <Typography variant="h6" gutterBottom>Quais informações são coletadas?</Typography>
      <Typography variant="body1" paragraph>
        As informações podem ser obtidas pelo uso do site (comportamento de navegação, cliques, páginas visitadas).
      </Typography>

      <Typography variant="h6" gutterBottom>Como usamos essas informações?</Typography>
      <Typography variant="body1" paragraph>
        Os dados são utilizados para personalizar o conteúdo, melhorar os serviços, gerar estatísticas e mostrar anúncios relevantes. Dados pessoais identificáveis não são comercializados.
      </Typography>

      <Typography variant="h6" gutterBottom>Compartilhamento com terceiros</Typography>
      <Typography variant="body1" >
        Podemos compartilhar dados anonimizados com parceiros para fins de publicidade. Utilizamos tecnologias como as da LiveRamp para criar identificadores que ajudam na personalização da experiência.
      </Typography>

      <Typography variant="h6" gutterBottom>Esta política se aplica a todos os conteúdos?</Typography>
      <Typography variant="body1" paragraph>
        Não. Anúncios de terceiros e links externos seguem políticas próprias. Recomendamos verificar as diretrizes de privacidade dos sites acessados por meio desses links.
      </Typography>

      <Typography variant="h6" gutterBottom>Posso optar por não compartilhar meus dados?</Typography>
      <Typography variant="body1" paragraph>
        Sim. Você pode desativar cookies, navegar de forma anônima ou optar por não participar de campanhas. Alguns recursos podem ser limitados caso faça isso.
      </Typography>

      <Typography variant="h6" gutterBottom>Como a experiência é personalizada?</Typography>
      <Typography variant="body1" paragraph>
        Usamos seu histórico de navegação para oferecer conteúdos e anúncios que tenham mais a ver com você. Caso prefira, é possível ajustar essas preferências ou desativar a personalização.
      </Typography>

      <Typography variant="h6" gutterBottom>Fale com a gente</Typography>
      <Typography variant="body1">
        Em caso de dúvidas, envie uma mensagem para <strong>ADICIONAR EMAIL DE CONTATO AQUI</strong>.
      </Typography>
    </Box>
  );
}